"use client";

import { useNativeSignIn } from "@/hooks/useNativeSignIn";
import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/client/analytics";

type SignInPromptProps = {
  onClose: () => void;
};

export default function SignInPrompt({ onClose }: SignInPromptProps) {
  const { openSignIn } = useNativeSignIn();
  const hasPromptedRef = useRef(false);

  useEffect(() => {
    if (hasPromptedRef.current) return;
    hasPromptedRef.current = true;
    try {
      trackEvent("sign_in_prompt_shown", "session", {
        trigger: "browse_threshold",
      });
    } catch {
      // Analytics must never affect sign-in flow
    }
    void openSignIn();
    onClose();
  }, [onClose, openSignIn]);

  return null;
}
